import { useQuery } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TSystemTimeHook = {
  isError: boolean;
  isLoading: boolean;
  data: { time: string } | undefined;
};

function useGetSystemTime(): TSystemTimeHook {
  const sdk = useApiSDK();

  const { isError, isLoading, data } = useQuery({
    queryKey: ['system-time'],
    queryFn: () => sdk.system.time(),
    refetchOnWindowFocus: true,
  });

  return { isError, isLoading, data };
}

export { useGetSystemTime };
